import React from 'react';
import type { MessageReaction } from '../../types/message';

interface MessageReactionsProps {
  reactions: MessageReaction[];
}

export const MessageReactions: React.FC<MessageReactionsProps> = ({ reactions }) => {
  if (!reactions || reactions.length === 0) return null;

  // Group reactions by emoji and count
  const groupedReactions = reactions.reduce((acc, reaction) => {
    const emoji = reaction.emoji;
    if (!acc[emoji]) {
      acc[emoji] = { emoji, count: 0, from: [] };
    }
    acc[emoji].count += 1;
    acc[emoji].from.push(reaction.from);
    return acc;
  }, {} as Record<string, { emoji: string; count: number; from: string[] }>);

  const reactionList = Object.values(groupedReactions);

  return (
    <div className="flex flex-wrap gap-1 mt-1">
      {reactionList.map((reaction, idx) => (
        <span
          key={idx}
          className="inline-flex items-center gap-0.5 px-1.5 py-0.5 bg-warm-white rounded-full shadow-sketch border border-sketch text-sm"
          title={reaction.from.join(', ')}
        >
          <span>{reaction.emoji}</span>
          {reaction.count > 1 && (
            <span className="text-xs text-graphite">{reaction.count}</span>
          )}
        </span>
      ))}
    </div>
  );
};

export default MessageReactions;
